import type { MqttContainer, MqttValue } from './types'
import { MqttTopic } from './topics'

export const instantaneousCadence: MqttValue = {
  title: 'cadence',
  unit: 'RPM',
  topic: MqttTopic.RESISTANCE_INSTANTANEOUS_CADENCE,
}

export const accumulatedPower: MqttValue = {
  title: 'accumulated power',
  unit: 'W',
  topic: MqttTopic.RESISTANCE_ACCUMULATED_POWER,
}

export const instantaneousPower: MqttValue = {
  title: 'power',
  unit: 'W',
  topic: MqttTopic.RESISTANCE_INSTANTANEOUS_POWER,
}

export const distance: MqttValue = {
  title: 'distance',
  unit: 'm',
  topic: MqttTopic.RESISTANCE_DISTANCE,
}

export const speed: MqttValue = {
  title: 'speed',
  unit: 'km/h',
  topic: MqttTopic.RESISTANCE_SPEED,
  decimalPlaces: 1,
}

export const wheelCircumfrence: MqttValue = {
  title: 'wheel circumference',
  unit: 'm/s',
  topic: MqttTopic.RESISTANCE_WHEEL_CIRCUMFRENCE,
}

export const resistanceLevel: MqttValue = {
  title: 'resistance level',
  unit: '%',
  topic: MqttTopic.RESISTANCE_LEVEL,
  editable: true,
  decimalPlaces: 1,
}

export const powerTarget: MqttValue = {
  title: 'power target',
  unit: 'W',
  topic: MqttTopic.RESISTANCE_POWER_TARGET,
  editable: true,
}

export const resistanceDefinitions: MqttContainer = {
  title: 'Resistance',
  prefix: 'resistance/',
  values: [
    instantaneousCadence,
    accumulatedPower,
    instantaneousPower,
    distance,
    speed,
    wheelCircumfrence,
    resistanceLevel,
    powerTarget,
  ],
}

export default resistanceDefinitions
